import { render } from "./TrainingDetail_CorporateTraining.vue?vue&type=template&id=535a793a&scoped=true"
import script from "./TrainingDetail_CorporateTraining.vue?vue&type=script&lang=js"
export * from "./TrainingDetail_CorporateTraining.vue?vue&type=script&lang=js"

import "./TrainingDetail_CorporateTraining.vue?vue&type=style&index=0&id=535a793a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a793a"]])

export default __exports__